export default {"src":"/_next/static/media/filing.1d76193d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};